import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import * as layouts from "./layouts";
import { Container, Divider, Grid, Typography } from "@material-ui/core";
import LayoutContainer from "../../components/LayoutsContainer";
import UseMobile from "../../hooks/useIsMobile";
import ContainerCard from "./ContainerCard";

const Background = "/images/background/SchemesBg.png";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundImage: `url(${Background})`,
    // background: `url (${Background})`,
    backgroundSize: `100% 150%`,
    backgroundRepeat: "no-repeat",
    // height: "75vh",
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(10),
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      background: `none`,
      height: "auto",
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      marginTop: theme.spacing(0),

      // backgroundColor: "red",
    },
  },
}));

const SubLayouts = ({ data }) => {
  const classes = useStyles();
  const isMobile = UseMobile();
  return (
    <div className={classes.root}>
      <LayoutContainer>
        {/* <Divider /> */}

        {data && (
          <>
            <Grid container spacing={!isMobile ? 2 : 2}>
              {data?.data?.map((layout, index) => {
                const Component = layouts[layout.type];
                return (
                  <Grid
                    item
                    lg={layout?.width || "auto"}
                    md={layout?.width || "auto"}
                    sm={12}
                    xs={12}
                    key={index}
                    // style={{ backgroundColor: "red", height: "100" }}
                  >
                    <Component {...layout} />
                  </Grid>
                );
              })}
            </Grid>
          </>
        )}
      </LayoutContainer>
    </div>
  );
};
export default SubLayouts;
